import { useState, useEffect } from 'react'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { useAuth } from '../context/AuthContext'

export function useUnreadNotifications() {
  const [unreadCount, setUnreadCount] = useState(0)
  const { currentUser } = useAuth()

  useEffect(() => {
    const fetchUnreadCount = async () => {
      if (!currentUser) return

      try {
        const notificationsRef = collection(db, 'Notifications')
        const q = query(
          notificationsRef,
          where('toUid', '==', currentUser.uid),
          where('read', '==', false)
        )
        const querySnapshot = await getDocs(q)
        setUnreadCount(querySnapshot.size)
      } catch (error) {
        console.error('Error fetching unread notifications:', error)
      }
    }

    fetchUnreadCount()

    // Set up real-time listener for unread notifications
    const interval = setInterval(fetchUnreadCount, 5000) // Check every 5 seconds

    return () => clearInterval(interval)
  }, [currentUser])

  return unreadCount
}
